import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1685.000000 694.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,588.000000) scale(0.100000,-0.100000)"
        >
          <path d="M3342 4939 c-62 -12 -145 -44 -194 -75 -106 -67 -85 -34 -1172 -1781
-103 -166 -188 -306 -189 -310 -1 -4 23 -8 53 -8 30 1 177 2 325 3 l270 2 28
48 c15 26 64 106 109 177 77 123 632 1014 780 1252 38 61 81 120 96 130 23 16
53 18 226 21 216 4 264 -4 297 -51 9 -12 106 -166 216 -342 111 -176 329 -525
486 -775 l286 -455 321 -3 c272 -2 321 0 317 12 -5 12 -364 590 -442 711 -18
28 -108 172 -200 320 -92 149 -182 293 -200 320 -18 28 -106 169 -196 314
-197 317 -252 383 -373 441 -45 21 -108 43 -140 49 -70 13 -640 13 -704 0z"/>
<path d="M12610 3450 l0 -680 60 0 60 0 0 80 0 80 66 -65 c75 -73 136 -102
248 -116 246 -32 467 125 531 376 55 214 -56 450 -257 549 -183 90 -368 66
-512 -66 l-66 -60 0 291 0 291 -65 0 -65 0 0 -680z m644 111 c71 -35 122 -86
164 -166 24 -45 27 -60 27 -155 0 -92 -3 -112 -26 -160 -70 -147 -225 -228
-385 -201 -84 15 -114 31 -180 93 -96 91 -136 236 -100 364 20 69 48 114 102
167 73 72 147 98 261 93 57 -2 86 -10 137 -35z"/>
<path d="M10682 4099 c-122 -24 -233 -112 -272 -216 -18 -48 -21 -72 -17 -133
13 -185 109 -277 377 -360 203 -63 263 -99 300 -178 18 -38 21 -59 17 -110
-13 -164 -163 -257 -359 -224 -85 15 -145 45 -217 112 -30 28 -57 50 -59 50
-13 0 -92 -73 -92 -84 0 -18 74 -85 142 -130 77 -51 159 -78 260 -84 205 -12
363 70 436 226 23 49 27 70 27 152 -1 83 -4 102 -28 151 -54 111 -180 195
-379 252 -153 45 -241 96 -271 160 -21 43 -22 138 -3 176 73 140 327 162 478
41 20 -17 40 -30 45 -30 4 0 28 18 53 40 l45 40 -38 34 c-110 99 -291 146
-445 115z"/>
<path d="M6416 3733 c-83 -192 -175 -406 -206 -478 -122 -278 -154 -352 -181
-417 l-28 -68 123 0 124 0 51 117 c28 64 54 127 57 140 l6 23 318 0 317 0 28
-67 c16 -38 43 -101 61 -140 l33 -73 121 0 c66 0 120 4 120 9 0 4 -32 82 -71
172 -39 90 -114 263 -166 384 -52 121 -122 283 -156 360 -33 77 -83 194 -111
260 l-52 120 -119 3 -120 3 -149 -348z m290 20 c18 -43 97 -230 160 -381 24
-57 44 -105 44 -107 0 -3 -101 -5 -225 -5 -124 0 -225 4 -225 9 0 8 205 495
216 513 9 14 15 9 30 -29z"/>
<path d="M7480 3980 l0 -100 320 0 c176 0 320 -3 320 -6 0 -3 -82 -116 -182
-252 -100 -136 -216 -294 -257 -351 -42 -56 -111 -150 -153 -208 l-78 -104 0
-95 0 -94 490 0 490 0 0 100 0 100 -340 0 c-187 0 -340 4 -340 8 0 8 19 35
115 167 87 119 354 483 452 617 l93 127 0 96 0 95 -465 0 -465 0 0 -100z"/>
<path d="M9066 4048 c-8 -18 -28 -67 -46 -108 -18 -41 -40 -93 -50 -115 -10
-22 -88 -204 -175 -405 -86 -201 -184 -426 -216 -501 -32 -75 -59 -139 -59
-143 0 -3 55 -6 123 -6 l122 0 60 140 59 140 316 0 315 0 42 -103 c24 -56 50
-119 58 -139 l15 -38 126 0 c97 0 125 3 121 13 -3 6 -65 149 -137 317 -247
571 -301 695 -362 838 l-61 142 -118 0 -119 0 -14 -32z m206 -415 c36 -87 86
-206 111 -265 l46 -108 -230 0 c-126 0 -229 2 -229 4 0 3 136 323 207 489 9
20 19 37 23 37 3 0 36 -71 72 -157z"/>
<path d="M11477 3704 c-10 -11 -8 -527 3 -609 19 -150 86 -252 202 -309 90
-44 241 -51 334 -16 50 20 132 81 159 120 15 21 38 69 51 105 23 64 24 73 24
390 l0 325 -64 0 -65 0 -3 -322 -3 -323 -27 -57 c-89 -190 -388 -177 -458 19
-10 28 -15 127 -19 358 l-6 320 -60 3 c-34 2 -64 0 -68 -4z"/>
<path d="M3140 3324 c0 -149 9 -189 49 -230 27 -27 491 -324 507 -324 4 0 61
35 128 77 67 42 171 108 231 146 187 118 188 120 191 310 1 87 -2 137 -8 137
-6 0 -129 -74 -274 -165 -145 -91 -266 -165 -268 -165 -5 0 -107 63 -365 227
-90 58 -170 107 -177 110 -11 4 -14 -19 -14 -123z"/>
</g>
</svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
